import jwtDecode from 'jwt-decode'
import FuncionalidadeService from '@/services/modules/FuncionalidadeService'
import DocumentoService from '@/services/modules/DocumentoService'
import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'

export default async function useLocalStorage(accessToken) {
  const { setAccessToken, setFuncionalidades } = useAuthStore()
  const { setUserData } = useUserStore()

  const decoded = jwtDecode(accessToken)

  setAccessToken(accessToken)

  const avatar = await DocumentoService.getFotoPerfil(parseInt(decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'], 10))

  const user = {
    id: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
    nome: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
    ide: decoded.ide,
    avatar,
  }
  setUserData(user)

  const funcionalidadesIds = await FuncionalidadeService.getFuncionalidadesByColaborador()
  setFuncionalidades(funcionalidadesIds)
}
